module.exports = __webpack_public_path__ + "img/footer_profile.30104c36.jpg";